/* eslint-disable no-param-reassign */

/**
 * Toggle class helper method
 * @param {DOMelement} el - the element to toggle a class
 * @param {String} className - the class to toggle
 * @return {DOMelement} el the original element
 */
var toggleClass = function toggleClass(element, className) {
  if (element === null) {
    return element;
  }

  if (element.classList) {
    element.classList.toggle(className);
  } else {
    var classes = element.className.split(' ');
    var existingIndex = classes.indexOf(className);

    if (existingIndex >= 0) {
      classes.splice(existingIndex, 1);
    } else {
      classes.push(className);
    }

    element.className = classes.join(' ');
  }

  return element;
};

export default toggleClass;